<template>
  <div class="paypal" :class="{'is-disabled': disabled}">
    <div v-if="!scriptLoaded">Loading...</div>
    <div id="paypal-button-container"></div>
  </div>
</template>

<script>
import { PAYPAL_URL } from '@/utilities/payment';
import { getBigAmount } from '@/utilities/money';

export default {
  name: 'PaypalButton',
  props: {
    amount: Number,
    currency: String,
    email: String,
    description: String,
    disabled: Boolean,
  },
  data() {
    return {
      scriptLoaded: false,
      paypalInstance: null,
      response: null,
    };
  },
  beforeMount() {
    const vm = this;
    const script = document.createElement('script');
    script.src = PAYPAL_URL[process.env.NODE_ENV];
    script.onload = () => {
      vm.scriptLoaded = true;
    };
    document.body.append(script);
  },
  watch: {
    scriptLoaded() {
      this.render();
    },
    $props(value) {
      this.update(value);
    },
  },
  methods: {
    update(value) {
      if (value && this.renderDelay) {
        clearTimeout(this.renderDelay);
        this.renderDelay = null;
      }
      this.renderDelay = setTimeout(() => this.render(), this.delaySeconds);
    },
    render() {
      const vm = this;
      const divId = 'paypal-button-container';
      const div = document.getElementById(divId);
      if (div) {
        div.innerHTML = '';
      }
      const purchaseUnits = [{
        amount: {
          currency_code: this.currency,
          value: getBigAmount(this.amount),
        },
        description: this.description,
      }];
      const payer = {
        email_address: this.email,
      };
      window.paypal.Buttons({
        createOrder(data, actions) {
          return actions.order.create({
            payer,
            purchase_units: purchaseUnits,
          });
        },
        onApprove(data, actions) {
          // To do: Verify on cloud function
          return actions.order.capture().then((details) => {
            vm.$emit('complete', {
              processor: 'paypal',
              response: {
                ...data,
                details,
              },
            });
          });
        },
      }).render(`#${divId}`);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.paypal {
  position: relative;
  height: 150px;
  z-index: 0;
  &.is-disabled {
    opacity: 0.5;
    pointer-events: none;
  }
}
</style>
